import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { capitalize } from "@utdanningsdirektoratet/utils/string";
import styles from "./DetailedList.module.less";

type DetailedListRowProps = {
  className?: string;
  inline?: boolean;
  header?: boolean;
  color?: "blue" | "grey" | "white";
  children?: ((props: { className: string }) => React.ReactNode) | React.ReactNode;
};

const DetailedListRow: React.FC<DetailedListRowProps> = ({ className, inline, header, children, color }) => {
  const rowClass = cls(
    {
      [styles.detailedListRow]: true,
      [styles.detailedListRowClickable]: typeof children === "function",
      [styles.detailedListRowInline]: inline,
      [styles.detailedListRowHeader]: header,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [styles[`detailedListRow${capitalize(color)}`]]: color,
    },
    className
  );
  let content: React.ReactNode;
  if (typeof children === "function") {
    content = (children as (a: unknown) => React.ReactNode)({
      className: rowClass,
    });
  } else {
    content = <div className={rowClass}>{children}</div>;
  }
  return content as React.ReactElement;
};

export default DetailedListRow;
